import React from "react";
import { Typography, Grid, Box } from "@mui/material";

const NotFound = () => {

  return (
    <Grid>
      <Grid className="d-flex justify-content-center align-items-center text-center" height={"100vh"}>
        <Box>
          <Typography className="f-20 poppins-font-family f-bold">
            Not Found
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NotFound;
